"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRedeemReferralDto = instanceOfRedeemReferralDto;
exports.RedeemReferralDtoFromJSON = RedeemReferralDtoFromJSON;
exports.RedeemReferralDtoFromJSONTyped = RedeemReferralDtoFromJSONTyped;
exports.RedeemReferralDtoToJSON = RedeemReferralDtoToJSON;
exports.RedeemReferralDtoToJSONTyped = RedeemReferralDtoToJSONTyped;
/**
 * Check if a given object implements the RedeemReferralDto interface.
 */
function instanceOfRedeemReferralDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    return true;
}
function RedeemReferralDtoFromJSON(json) {
    return RedeemReferralDtoFromJSONTyped(json, false);
}
function RedeemReferralDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
    };
}
function RedeemReferralDtoToJSON(json) {
    return RedeemReferralDtoToJSONTyped(json, false);
}
function RedeemReferralDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
    };
}
